<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-form :model="selectForm" ref="selectFormRef" :inline="true" label-width="80px" class="font-bold">
        <el-form-item label="任务名" prop="JobName" >
          <el-input size="small" v-model="selectForm.JobName" clearable placeholder="请输入任务名"></el-input>
        </el-form-item>
        <el-form-item label="方法" prop="InvokeTarget" >
          <el-input size="small" v-model="selectForm.InvokeTarget" clearable placeholder="请输入方法"></el-input>
        </el-form-item>
        <el-form-item label="执行策略" prop="MisfirePolicy" >
          <el-select class="width-100" size="small" v-model="selectForm.MisfirePolicy" placeholder="请选择执行策略">
            <el-option
              v-for="item in options1"
              size="small"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status" >
          <el-select class="width-100" size="small" v-model="selectForm.status" placeholder="请选择状态">
            <el-option
              v-for="item in options"
              size="small"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="margin-l-20">
          <el-button size="small"  @click="getTasks(true)">搜索</el-button>
          <el-button size="small" @click="resetInput">重置</el-button>
          <el-button size="small" type="primary" @click="addDialogVisible = true">新增任务</el-button>
        </el-form-item>
      </el-form>

      <!-- 任务列表区域 -->
      <el-table :data="taskList" border stripe>
        <el-table-column label="编号" type="index"></el-table-column>
        <el-table-column label="任务ID" prop="JobId"></el-table-column>
        <el-table-column label="任务名称" prop="JobName"></el-table-column>
        <el-table-column label="任务分组" prop="JobGroup"></el-table-column>
        <el-table-column label="任务方法名" prop="InvokeTarget"></el-table-column>
        <el-table-column label="方法参数" prop="JobParams"></el-table-column>
        <el-table-column label="cron执行表达式" prop="CronExpression"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.Status"
              active-value="0"
              inactive-value="1"
              @change="stateChanged(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-tooltip effect="dark" content="修改" placement="top" :enterable="false">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)"></el-button>
            </el-tooltip>
            <!-- 删除按钮 -->
            <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeTaskById(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!--     添加任务的对话框-->
    <el-dialog title="添加任务" :visible.sync="addDialogVisible" width="30%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="任务名称" prop="JobName">
          <el-input v-model="addForm.JobName" placeholder="请输入任务名称"></el-input>
        </el-form-item>
        <el-form-item label="cron表达式" prop="CronExpression">
          <el-input v-model="addForm.CronExpression" placeholder="请输入cron表达式"></el-input>
        </el-form-item>
        <el-form-item label="方法参数" prop="JobParams">
          <el-input v-model="addForm.JobParams" placeholder="请输入方法参数"></el-input>
        </el-form-item>
        <el-form-item label="执行方法" prop="InvokeTarget">
          <el-input v-model="addForm.InvokeTarget" placeholder="请输入执行方法"></el-input>
        </el-form-item>
        <el-form-item label="执行策略" prop="MisfirePolicy">
          <el-radio-group v-model="addForm.MisfirePolicy">
            <el-radio label="1">重复执行</el-radio>
            <el-radio label="2">执行一次</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTask">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改任务的对话框 -->
    <el-dialog title="修改任务" :visible.sync="editDialogVisible" width="30%" @close="editDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="90px">
        <el-form-item label="任务名称" prop="JobName">
          <el-input v-model="editForm.JobName" placeholder="请输入任务名称"></el-input>
        </el-form-item>
        <el-form-item label="任务表ID" prop="JobId">
          <el-input disabled v-model="editForm.JobId"></el-input>
        </el-form-item>
        <el-form-item label="任务进程ID" prop="TaskId">
          <el-input disabled v-model="editForm.TaskId"></el-input>
        </el-form-item>
        <el-form-item label="cron表达式" prop="CronExpression">
          <el-input v-model="editForm.CronExpression" placeholder="请输入cron表达式"></el-input>
        </el-form-item>
        <el-form-item label="方法参数" prop="JobParams">
          <el-input v-model="editForm.JobParams" placeholder="请输入方法参数"></el-input>
        </el-form-item>
        <el-form-item label="执行方法" prop="InvokeTarget">
          <el-input v-model="editForm.InvokeTarget" placeholder="请输入执行方法"></el-input>
        </el-form-item>
        <el-form-item label="执行策略" prop="MisfirePolicy">
          <el-radio-group v-model="editForm.MisfirePolicy">
            <el-radio :label="1">重复执行</el-radio>
            <el-radio :label="2">执行一次</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="editForm.Status">
            <el-radio :label="1">停用</el-radio>
            <el-radio :label="0">正常</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editTaskInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { chat_del, chat_get, chat_post, chat_task, toForm } from '@/api'
  let id = 0;

  export default {
    name: 'timedTask',
    data() {
      return {
        // 获取任务列表的参数对象
        queryInfo: {
          query: '',
          // 当前的页数
          pagenum: 1,
          // 当前每页显示多少条数据
          pagesize: 10
        },

        options: [{
          value: '1',
          label: '停用'
        }, {
          value: '0',
          label: '正常'
        }],
        options1: [{
          value: '2',
          label: '执行一次'
        }, {
          value: '1',
          label: '重复执行'
        }],
        addFormRules: {
          JobName: [
            { required: true, message: '请输入任务名称', trigger: 'blur' },
          ],
        },
        editDialogVisible: false,
        selectForm: {
          JobName	: '',
          InvokeTarget: '',
          status: '',
          MisfirePolicy: ''
        },
        addForm: {
          MisfirePolicy: '1',
          JobName: '',
          InvokeTarget: '',
          CronExpression: '',
          JobParams: ''
        },
        taskList: [],
        deptlist: [],
        total: 0,
        editForm: {},
        // 控制添加任务对话框的显示与隐藏
        addDialogVisible: false,
        props: {
          label: 'DeptName',
          children: 'children',
          isLeaf: 'leaf'
        }
      }
    },
    created() {
      this.getTasks()
    },
    methods: {
      getTasks(val = false) {
        let vm = this;
        let {JobName, InvokeTarget, status, MisfirePolicy} = this.selectForm;
        chat_get(`/admin/v1/cron?size=${this.queryInfo.pagesize}&page=${this.queryInfo.pagenum}&JobName=${JobName}&InvokeTarget=${InvokeTarget}&status=${status}&MisfirePolicy=${MisfirePolicy}`, {}, res => {
          if(res.status == 200) {
            vm.taskList = res.data.MessageContent.List;
            vm.total = res.data.MessageContent.Total;
          }
        })
      },
      // 点击按钮，添加新任务
      addTask() {
        let params = toForm(this.addForm)
        this.$refs.addFormRef.validate(valid => {
          if (!valid) return
          chat_post('admin/v1/cron', params, res => {
            if(res.data.hasOwnProperty('message'))  {
              this.$message.error(res.data.message)
            }else {
              this.$message.success('添加任务成功！')
              // 隐藏添加任务的对话框
              this.addDialogVisible = false
              // 重新获取任务列表数据
              this.getTasks()
            }
          })
        })
      },
      // 展示编辑任务的对话框
      showEditDialog(val) {
        chat_get(`admin/v1/cronById?id=${val.JobId}`, {}, res => {
          if(res.status == 200) {
            this.editForm = res.data.MessageContent
          }
        })
        this.editDialogVisible = true
      },
      stateChanged(value) {
        let {JobId, Status, JobName, InvokeTarget, CronExpression, TaskId, MisfirePolicy } = value;
        let params = toForm({
          JobId,
          status: Status,
          JobName,
          InvokeTarget,
          CronExpression,
          CronTaskId: TaskId,
          MisfirePolicy
        })
        chat_post('admin/v1/upCron', params, res => {
          if(res.status == 200 && res.data.hasOwnProperty('message')) {
            this.$message.error(res.data.message)
          }else {
            // 关闭对话框
            this.editDialogVisible = false
            // 提示修改成功
            this.$message.success('更新状态成功！')
          }
          // 刷新数据列表
          this.getTasks()
        })
      },

      // 监听 pagesize 改变的事件
      handleSizeChange(newSize) {
        this.queryInfo.pagesize = newSize
        this.getTasks()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange(newPage) {
        this.queryInfo.pagenum = newPage
        this.getTasks()
      },
      // 监听添加任务对话框的关闭事件
      addDialogClosed() {
        this.$refs.addFormRef.resetFields()
      },

      // 监听修改任务对话框的关闭事件
      editDialogClosed() {
        this.$refs.editFormRef.resetFields()
      },
      // 修改任务信息并提交
      editTaskInfo() {
        let {JobName, InvokeTarget, Status, CronExpression, JobId, TaskId, MisfirePolicy, JobParams} = this.editForm;
        let params = toForm({
          JobName,
          InvokeTarget,
          status: Status,
          CronExpression,
          JobId,
          CronTaskId: TaskId,
          MisfirePolicy,
          JobParams
        })
        this.$refs.editFormRef.validate(valid => {
          if (!valid) return
          chat_post('admin/v1/upCron', params, res => {
            if(res.status == 200 && res.data.hasOwnProperty('message')) {
              this.$message.error(res.data.message)
            }else {
              // 关闭对话框
              this.editDialogVisible = false
              // 刷新数据列表
              this.getTasks()
              // 提示修改成功
              this.$message.success('更新任务信息成功！')
            }
          })
        })
      },
      resetInput() {
        this.$refs.selectFormRef.resetFields()
        this.getTasks()
      },
      // 根据Id删除对应的任务信息
      removeTaskById(oneUser) {
        let vm = this;
        this.$confirm( `此操作将删除"${oneUser.JobName}", 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          chat_del(`admin/v1/cron/${oneUser.JobId}`, {}, res => {
            if(res.status == 200 && res.data.code != 400) {
              vm.getTasks()
              vm.$message({
                type: 'success',
                message: `删除成功!`
              });
            }else {
              vm.$message.error({
                type: 'success',
                message: `${res.data.message}`
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
    }
  }
</script>

<style scoped>
  .el-select-dropdown__item {
    padding: 0;
    text-align: center;
  }
</style>
